/*
|--------------------------------------------------------------------------
| Data: Filter By
|--------------------------------------------------------------------------
*/
/**
 * Filter stories
 * @namespace
 */
__gh__webApp.data.filterBy = {

	/**
	 * Limit data to galleries
	 * @param  {array} data - array of data objects
	 * @return {array}
	 */
	"gallery": function(data) {
		return __gh__webApp.common.filterBy({
			"data"		: data,
			"property"	: "type",
			"value"		: "gallery"
		});
	},

	/**
	 * Limit data to stories
	 * @param  {array} data - array of data objects
	 * @return {array}
	 */
	"story": function(data) {
		return __gh__webApp.common.filterBy({
			"data"		: data,
			"property"	: "type",
			"value"		: "story"
		});
	},

	/**
	 * Limit data to opinion
	 * @param  {array} data - array of data objects
	 * @return {array}
	 */
	"opinion": function(data) {
		return __gh__webApp.common.filterBy({
			"data"		: data,
			"property"	: "category",
			"value"		: "opinion"
		});
	},
};
